import React from 'react'
import Picture1 from "../../assets/Mr2.png"
import Picture2 from "../../assets/utibe.jpg"
import { GoPrimitiveDot } from "react-icons/go"
import "./Home.css"


const Home = () => {
  return (
    <div id='home' className='home px-4 lg:mt-5'>
      <div className='texts md:block hidden'>
        <h5 className='text-white slide-text1 text-3xl leading-[3.5rem]'>Hi There,</h5>
        <h5 className='text-white slide-text2 font-bold utee text-5xl leading-[3.5rem]'>I'm Utibe Etim.</h5>
        <h5 className='text-white slide-text3 text-3xl leading-[3.5rem]'>A Mobile Developer</h5>
      </div>
      <div className='text sm:hidden text-center'>
        <small className='text-white slide-text leading-[3.5rem]'>Hi There,</small>
        <p className='text-white utee slide-text font-bold leading-[3.5rem]'>I'm Utibe Etim </p>
        <p className='text-white  slide-text leading-[3.5rem]'>A Mobile Developer</p>
      </div>

      <div className='py-[3rem] md:flex  head-intro gap-8'>
        <div className='intro-image div mb-3'>
          <img src={Picture1} alt="Utibe's Picture" className='md:block utee_image1 rounded-tl-[2rem] rounded-br-[2rem]' />
          <img src={Picture2} alt="Utibe's Picture" className='sm:hidden utee_image2 rounded-md' />
        </div>
        <div className='intro-text div lg:block hidden '>
          <span className=''>I'm a mobile developer who's passionate about building projects <br /> and solutuions for mobile devices with the use of cutting-edge technologies</span>
          <p className='xl:py-[3.5rem] py-[3rem] '>I have extensive experience with writing clean code and building <br /> pixel-perfect mobile UIs with XML/Compose and Dart/Flutter.
          </p>
          <p className='flex items-center lg:mt-[3.5rem] '>
            <GoPrimitiveDot className='dot' />
            Currently Working at Tutorials.Eu
          </p>
        </div>





        <div className='intro-text tablet-text text-center hidden'>
          <p>
          I'm a mobile developer who's passionate about building projects and solutuions for mobile devices with the use of cutting-edge technologies
        </p>
          <p className='py-1'> I have extensive experience with writing clean code and building pixel-perfect mobile UIs with XML/Compose and Dart/Flutter.
          </p>
        </div>




        <div className='intro-text md:hidden py-2 text-center text'>
          <p>
          I'm a mobile developer who's passionate about building projects and solutuions for mobile devices with the use of cutting-edge technologies
            </p>
            
            <p className='py-2'>
            I have extensive experience with writing clean code and building pixel-perfect mobile UIs with XML/Compose and Dart/Flutter.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Home
